import { validatePresenceOf } from '@/shared/utils';

export const validate = appointments => {
  return validatePresenceOf(appointments, ['date', 'place']);
};
